import { Component, Input } from '@angular/core';
import { FormField } from '@shared/components/form/models/beans/form-field.abstract';

@Component({
    selector: 'numberfield',
    templateUrl: './numberfield.component.html',
    styleUrls: ['./numberfield.component.scss'],
})
export class NumberfieldComponent extends FormField {
    @Input() textEnd: boolean = true;
    @Input() showSeparators = true;
    @Input() suffix: string;
    @Input() prefix: string;
    @Input() maxFractionDigits = 2;
    @Input() maxIntegerDigits = 13;
}
